const CHUNK_RELOAD_KEY = "chunk_error_reload";
const CHUNK_RELOAD_EXPIRY = 10000; // 10 seconds - prevents reload loop

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const message = error.message.toLowerCase();
  return (
    message.includes("failed to fetch dynamically imported module") ||
    message.includes("importing a module script failed") ||
    message.includes("loading chunk") ||
    message.includes("loading css chunk")
  );
}

export function shouldAutoReload(): boolean {
  const lastReload = sessionStorage.getItem(CHUNK_RELOAD_KEY);
  if (!lastReload) return true;
  return Date.now() - parseInt(lastReload, 10) > CHUNK_RELOAD_EXPIRY;
}

export function attemptChunkErrorReload(): boolean {
  if (shouldAutoReload()) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, Date.now().toString());
    window.location.reload();
    return true;
  }
  return false;
}

export function clearReloadAttempt(): void {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

export function setupChunkErrorHandler(): void {
  window.addEventListener("vite:preloadError", (event) => {
    attemptChunkErrorReload();
    event.preventDefault();
  });
}
